// frontend/src/services/api.js
import axios from 'axios';

// Cria uma instância do axios com a URL base do nosso backend
// Ele lerá a variável do arquivo frontend/.env
const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

// Adiciona um interceptor para injetar o token de autenticação em cada requisição
api.interceptors.request.use(async (config) => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
        const user = JSON.parse(userStr);
        if (user.token) {
            config.headers.Authorization = `Bearer ${user.token}`;
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;